export default __webpack_public_path__ + "static/media/ko.5b5226af.svg";